import BenchlingConfig from 'BenchlingConfig';

export function isLLMFeedbackEnabled(): boolean {
  // disable feedback controls in validated cloud clients
  return !BenchlingConfig.VALIDATED_CLOUD_VERSION;
}
